/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'app/components/common/Modal.jsx';
import CreditCardModal from 'app/components/Subscription/CreditCardModal.jsx';
import TDSChallengeModal from 'app/components/Subscription/TDSChallengeModal.jsx';
import * as _ from 'underscore';
import PricingModule from 'app/mixins/PricingModule.jsx';
import GetPlanData from 'app/utility/GetPlanData.js';
import PlanDetailBlock from 'app/components/Subscription/PlanDetailBlock.jsx';
import classnames from 'classnames';
import { FormattedNumber } from 'react-intl';
import { compose } from 'redux';

class SubaccountSubscriptionModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            subscription: {
                newSub: null,
                level: 0,
                term: 0,
                minAddOns: 0,
                addOns: 0
            },
            showCCModal: false,
            isUpgrading: false,
            requestData: null,
            requestMethod: null,
            hasTDSChallenge: false,
            TDSChallenge: ''
        };

        this.changePlan = this.changePlan.bind(this);
        this.updateSubscription = this.updateSubscription.bind(this);

    }

    componentDidMount() {

        this.props.getPlans();

    }

    componentDidUpdate(prevProps, prevState) {
        let constants = this.props.app.config.constants,
            nextSubscription = Object.assign({}, this.state.subscription);

        // we gotta wait until the plans are loaded because they have valuable information we need
        if (Object.keys(this.props.plans.details).length === 0) {
            return;
        }

        let errors = this.props.getApiErrors(['SUB_UPDATE', 'SUB_ADDON_UPDATE', 'SUB_CREATE']);

		if (errors.length && !this.state.hasTDSChallenge) {
			let TDSChallenge = errors[0].errors?.subscription?.TDSChallenge;
			if (TDSChallenge !== undefined && TDSChallenge !== null) {
				this.setState({
					hasTDSChallenge: true,
                    TDSChallenge
				});
			}
        } else if (!errors.length && this.state.hasTDSChallenge) {
            this.setState({
                hasTDSChallenge: false,
                TDSChallenge: ''
            });
        }

        if (this.props.app.userLoaded && this.props.app.userPermsLoaded && this.state.subscription.newSub === null) {
            // set up subscription details for new or existing users
            if (this.props.user.detail.pubLevel <= constants.PUB_LEVEL_1) {
                nextSubscription.newSub = true;
                nextSubscription.level = constants.PUB_LEVEL_6;
                nextSubscription.term = constants.SUBSCRIPTION_TERM_MONTHLY;

                if (dataLayer && this.props.context === 'app') {
                    dataLayer.push({
                        'event': 'checkout',
                        'ecommerce': {
                            'checkout': {
                                'actionField': {'step': 1, 'option': 'New Subscriber - Subaccounts'}
                            }
                        }
                    });

                    // GA4 specific info
                    let planDetail = GetPlanData.lookupDetails(
                            nextSubscription.level,
                            nextSubscription.term
                        ),
                        items = [
                            {
                                item_id: planDetail.plan_id,
                                item_name: planDetail.plan_name,
                                price: planDetail.price,
                                quantity: 1,
                                item_variant: 'new-subaccount'
                            }
                        ],
                        addOnPrice = 0;

                    if (nextSubscription.addOns) {
                        addOnPrice = this.props.plans.details[nextSubscription.level].addOnPrices[nextSubscription.term] * nextSubscription.addOns;
                        items.push({
                            item_id: planDetail.plan_id + "_add_on_social",
                            item_name: planDetail.plan_name + " add on",
                            price: addOnPrice,
                            quantity: nextSubscription.addOns,
                            item_variant: 'new-addon'
                        });
                    }

                    if (planDetail) {
                        dataLayer.push({
                            'event': 'view_item',
                            'currency': 'USD',
                            'value': planDetail.price + addOnPrice,
                            'items': items
                        });
                    }
                }

            } else {
                nextSubscription.newSub = false;
                nextSubscription.level = this.props.user.plan.planLevel;
                nextSubscription.term = this.props.user.plan.planTerm;

                if (this.props.user.plan.addOns.add_on_social !== undefined) {
                    nextSubscription.addOns = this.props.user.plan.addOns.add_on_social.qty;
                    nextSubscription.minAddOns = this.props.user.plan.addOns.add_on_social.qty;
                }

                // get the current plan for the PricingModule
                this.props.getUserPlan();

            }

            // calculate how many addons are needed
            let plan = this.props.plans.details[nextSubscription.level],
                outputsAvailable = this.props.user.perms.resources.outputsAvailable,
                outputsInUse = this.props.user.perms.resources.outputsInUse,
                selectedCount = this.props.selectedSocials.length,
                requestedCount = selectedCount + outputsInUse;

            if (requestedCount > outputsAvailable) {
                let limitFound = false,
                    addOnQuantity = plan.addOnQuantity[constants.SUBSCRIPTION_ADDON_SOCIALS].socials;

                for (let i = 0; limitFound === false; ++i) {
                    if (requestedCount <= (parseInt(plan.limits.hardLimitOutputs) + addOnQuantity * i)) {
                        nextSubscription.minAddOns = i;
                        nextSubscription.addOns = i;
                        limitFound = true;
                        break;
                    }
                }
            }

            if (nextSubscription.newSub === false) {
                if (dataLayer && this.props.context === 'app') {
                    dataLayer.push({
                        'event': 'checkout',
                        'ecommerce': {
                            'checkout': {
                                'actionField': {'step': 1, 'option': 'Add ons - Subaccounts'}
                            }
                        }
                    });

                    // GA4 specific info
                    let planDetail = GetPlanData.lookupDetails(
                        nextSubscription.level,
                        nextSubscription.term
                    );
                    if (planDetail) {
                        let addOnPrice = nextSubscription.addOns * plan.addOnPrices[nextSubscription.term];

                        dataLayer.push({
                            'event': 'view_item',
                            'currency': 'USD',
                            'value': addOnPrice,
                            'items': [{
                                item_id: planDetail.plan_id + "_add_on_social",
                                item_name: planDetail.plan_name + ' add on',
                                price: addOnPrice,
                                quantity: nextSubscription.addOns,
                                item_variant: 'addons-subaccount'
                            }]
                        });
                    }
                }
            }

            this.setState({
                subscription: nextSubscription
            });

        }

        if ((prevProps.app.loading.SUB_CREATE === true && this.props.app.loading.SUB_CREATE === false) ||
            (prevProps.app.loading.SUB_UPDATE === true && this.props.app.loading.SUB_UPDATE === false) ||
            (prevProps.app.loading.SUB_ADDON_UPDATE === true && this.props.app.loading.SUB_ADDON_UPDATE === false)) {
            // if errors, don't do any of the glory bits
            if (errors.length > 0) {
                return;
            }

            // subscription has been updated reload the important bits
            this.props.getUser();
            this.props.getUserPerms();
            this.props.getUserPlan();
            this.props.getSocials(true);

            this.props.closeAllModals();
            // used by the parent (SubaccountSelector) to show the sticky footer again
            this.props.toggleModal(false);

            // make the call to create the batch socials

            // track some stuff too
            if (prevProps.app.loading.SUB_CREATE === true && this.props.app.loading.SUB_CREATE === false) {
                let subscription = this.props.plans.current,
                    products = [];

                // if (dataLayer) {
                //     let planDetail = GetPlanData.lookupDetails(
                //         this.props.plans.current.planLevel,
                //         this.props.plans.current.planTerm
                //     );
                //
                //     products.push({
                //         'name': subscription.planName,     // Name or ID is required.
                //         'price': subscription.price,
                //         'quantity': 1,
                //         'variant': 'subaccount-add-subscription'
                //     });
                //
                //     dataLayer.push({
                //         'event': 'purchase',
                //         'ecommerce': {
                //             'purchase': {
                //                 'actionField': {
                //                     'id': subscription.uuid, // Transaction ID. Required for purchases and refunds.
                //                     'revenue': subscription.price
                //                 },
                //                 'products': products
                //             }
                //         },
                //         // GA4 params
                //         'transaction_id': subscription.uuid,
                //         'value': 1.00,
                //         items: [
    	        //             {
    	        //                 item_id: 'dlvrit_1',
    	        //                 item_name: 'dlvr.it premium plan',
    	        //                 price: 1.00,
    	        //                 quantity: 1
    	        //             }
    	        //         ]
                //     });
                // }
                if (gtag) {
                    let promoData = this.props.getPersistedData('gaPromo');

                    gtag('event', 'purchase', {
                        transaction_id: subscription.uuid,
                        value: 1.00,
                        currency: 'USD',
                        items: [
                            {
                                item_id: 'dlvrit_1',
    	                        item_name: 'dlvr.it premium plan',
                                item_variant: 'New Plan',
    	                        price: 1.00,
    	                        quantity: 1,
                                promotion_id: (promoData && promoData.promotion_id) ? (promoData.promotion_id) : '',
                                promotion_name: (promoData && promoData.promotion_name) ? (promoData.promotion_name) : ''
                            }
                        ],

                    });

                    if (this.props.recordEvent) {
                        this.props.recordEvent({
                            pub_id: this.props.user.detail.id,
                            event_name: 'New Plan Purchase',
                            event_data: {
                                promotion_id: promo.id,
                                promotion_name: promo.name
                            }
                        })
                    }

                    this.props.clearPersistedData('gaPromo');
                }

            } else if (prevProps.app.loading.SUB_ADDON_UPDATE === true && this.props.app.loading.SUB_ADDON_UPDATE === false) {
                let subscription = this.props.plans.current,
                    products = [];

                // if (dataLayer) {
                //     let planDetail = GetPlanData.lookupDetails(
                //             this.props.plans.current.planLevel,
                //             this.props.plans.current.planTerm
                //         ),
                //         txID = subscription.uuid + "_addon_" + new Date().getTime();
                //
                //
                //     products.push({
                //         'name': subscription.planName + " add on",     // Name or ID is required.
                //         'price': subscription.addOns.add_on_social.cost,
                //         'quantity': subscription.addOns.add_on_social.qty,
                //         'variant': 'addons-subaccount'
                //     });
                //
                //     dataLayer.push({
                //         'event': 'purchase',
                //         'ecommerce': {
                //             'purchase': {
                //                 'actionField': {
                //                     'id': txID, // Transaction ID. Required for purchases and refunds.
                //                     'revenue': subscription.addOns.add_on_social.cost
                //                 },
                //                 'products': products
                //             }
                //         },
                //         // GA4 params
                //         'transaction_id': txID,
                //         'value': subscription.price,
                //         'items': [{
                //             item_id: planDetail.plan_id + "_add_on_social",
                //             item_name: planDetail.plan_name + " add on",
                //             item_variant: 'addons-subaccount',
                //             quantity: subscription.addOns.add_on_social.qty,
                //             price: subscription.addOns.add_on_social.cost
                //         }]
                //     });
                // }

                if (gtag) {
                    let txID = subscription.uuid + "_addon_" + new Date().getTime(),
                        promoData = this.props.getPersistedData('gaPromo');

                    gtag('event', 'purchase', {
                        transaction_id: txID,
                        value: 1.00,
                        currency: 'USD',
                        items: [
                            {
                                item_id: 'dlvrit_1',
    	                        item_name: 'dlvr.it premium plan',
                                item_variant: 'Purchase Add-On',
    	                        price: 1.00,
    	                        quantity: 1,
                                promotion_id: (promoData && promoData.promotion_id) ? (promoData.promotion_id) : '',
                                promotion_name: (promoData && promoData.promotion_name) ? (promoData.promotion_name) : ''
                            }
                        ],

                    });

                    if (this.props.recordEvent) {
                        this.props.recordEvent({
                            pub_id: this.props.user.detail.id,
                            event_name: 'Add-On Purchase',
                            event_data: {
                                promotion_id: (promoData && promoData.promotion_id) ? (promoData.promotion_id) : '',
                                promotion_name: (promoData && promoData.promotion_name) ? (promoData.promotion_name) : ''
                            }
                        })
                    }

                    this.props.clearPersistedData('gaPromo');
                }
            }


        }
    }

    changePlan(e) {
        let term = e.currentTarget.dataset.term || null,
            addOns = e.currentTarget.dataset.addons || null,
            nextSubscription = Object.assign({}, this.state.subscription);

        if (term) {
            nextSubscription.term = parseInt(term);
        }

        if (addOns) {
            addOns = parseInt(addOns);
            if (nextSubscription.addOns + addOns >= nextSubscription.minAddOns) {
                nextSubscription.addOns += addOns;

                // GA4 specific info
                let planDetail = GetPlanData.lookupDetails(
                    nextSubscription.level,
                    nextSubscription.term
                );
                if (planDetail) {
                    let plan = this.props.plans.details[nextSubscription.term],
                        addOnPrice = nextSubscription.addOns * plan.addOnPrices[nextSubscription.term];

                    dataLayer.push({
                        'event': 'view_item',
                        'currency': 'USD',
                        'value': addOnPrice,
                        'items': [{
                            item_id: planDetail.plan_id + "_add_on_social",
                            item_name: planDetail.plan_name + ' add on',
                            price: addOnPrice,
                            quantity: nextSubscription.addOns,
                            item_variant: 'addons-subaccount'
                        }]
                    });
                }

            }

        }

        if (!_.isEqual(this.state.subscription, nextSubscription)) {
            this.setState({
                subscription: nextSubscription
            });
        }

    }

    updateSubscription() {
        let data = {
            add_on_social: this.state.subscription.addOns
        };

        // clear out errors as this might be a second attempt after a 3DS challenge
        this.props.deleteApiError(['SUB_UPDATE', 'SUB_ADDON_UPDATE', 'SUB_CREATE']);

        this.props.updateAddOns(data);

        this.setState({
            isUpgrading: true,
            requestData: data,
            requestMethod: this.props.updateAddOns
        });

    }

    render() {
        let modalContent = null,
            content = null,
            headline = '',
            planOptions = [],
            constants = this.props.app.config.constants;

        // make sure the plans are loaded and have had a chance to update the state subscription
        // object before rendering anything (less breaky-breaky that way)
        if (Object.keys(this.props.plans.details).length === 0 || this.state.subscription.level === 0) {
            return null;
        }

        if (this.state.hasTDSChallenge) {
            content = (
                <TDSChallengeModal
                    {...this.props}
                    TDSChallenge={this.state.TDSChallenge}
                    requestData={this.state.requestData}
                    requestMethod={this.state.requestMethod}/>
            );
        } else if (this.state.showCCModal) {
            content = (
                <CreditCardModal
                    {...this.props}
                    plan={this.state.subscription.level}
                    username={this.props.user.detail.username}
                    planTerm={this.state.subscription.term}
                    addOns={{
                        add_on_social: this.state.subscription.addOns
                    }}
                    changeTerm={this.changeTerm}
                    close={() => {
                        this.props.closeAllModals();
                        this.props.toggleModal(false);
                    }} />
            );
        } else {
            let socialLabel = this.props.selectedSocials.length === 1 ? 'social' : 'socials',
                buttonLabel = '',
                annualSelectorClass = classnames('term-selector', {
                    'selected': this.state.subscription.term === constants.SUBSCRIPTION_TERM_ANNUAL
                }),
                monthlySelectorClass = classnames('term-selector', {
                    'selected': this.state.subscription.term === constants.SUBSCRIPTION_TERM_MONTHLY
                }),
                annualMonthly = Object.keys(this.props.plans.details).length ? this.props.plans.details[constants.PUB_LEVEL_6].price[constants.SUBSCRIPTION_TERM_ANNUAL] / 12 : 0,
                monthlyPrice = Object.keys(this.props.plans.details).length ? this.props.plans.details[constants.PUB_LEVEL_6].price[constants.SUBSCRIPTION_TERM_MONTHLY] : 0,
                savingsPct = 28;

            if (this.state.subscription.addOns > 0) {
                if (this.props.plans.details[constants.PUB_LEVEL_6] !== undefined) {
                    annualMonthly = (this.props.plans.details[constants.PUB_LEVEL_6].price[constants.SUBSCRIPTION_TERM_ANNUAL] +
                                    (this.props.plans.details[constants.PUB_LEVEL_6].addOnPrices[constants.SUBSCRIPTION_TERM_ANNUAL] * this.state.subscription.addOns)) / 12;
                    monthlyPrice = (this.props.plans.details[constants.PUB_LEVEL_6].price[constants.SUBSCRIPTION_TERM_MONTHLY] +
                                    (this.props.plans.details[constants.PUB_LEVEL_6].addOnPrices[constants.SUBSCRIPTION_TERM_MONTHLY] * this.state.subscription.addOns));
                }
            }

            if (this.props.user.detail.pubLevel <= constants.PUB_LEVEL_1 && this.state.showCCModal === false) {
                headline = `DLVR.IT PRO`;
                buttonLabel = 'Subscribe';

                let termButtons = (
                    <div className="term-buttons">
                        <div className="term-button">
                            <div className="savings-sticker">
                                <div className="save">Save</div>
                                <div>{savingsPct}%</div>
                            </div>
                            <div className={annualSelectorClass} data-term={constants.SUBSCRIPTION_TERM_ANNUAL} onClick={this.changePlan} role="button" aria-label="pay annually">
                                <div className="term">
                                    Billed Annually
                                </div>
                                <div className="price">
                                    <FormattedNumber value={annualMonthly} style="currency" currency="USD"/> / month
                                </div>
                            </div>
                        </div>
                        <div className="term-divider">
                            or
                        </div>
                        <div className="term-button">
                            <div className={monthlySelectorClass} data-term={constants.SUBSCRIPTION_TERM_MONTHLY} onClick={this.changePlan} role="button" aria-label="pay monthly">
                                <div className="term">
                                    Billed Monthly
                                </div>
                                <div className="price">
                                    <FormattedNumber value={monthlyPrice} style="currency" currency="USD"/> / month
                                </div>
                            </div>
                        </div>
                    </div>
                );

                modalContent = (
                    <PlanDetailBlock
                        context="new-subaccount"
                        currentPlan={this.state.subscription.level}
                        currentTerm={this.state.subscription.term}
                        addOns={{
                            min: this.state.subscription.minAddOns,
                            qty: this.state.subscription.addOns
                        }}
                        onAddOnClick={this.changePlan}
                        startUpgrade={() => {
                            this.setState({
                                showCCModal: true
                            });
                        }}
                        termButtons={termButtons}
                        {...this.props}/>
                );
            } else {
                let limits = this.props.calculateAddOns([{
                        addOn: constants.SUBSCRIPTION_ADDON_SOCIALS,
                        quantity: this.state.subscription.addOns
                    }]),
                    currentLimits = this.props.calculateAddOns([{
                        addOn: constants.SUBSCRIPTION_ADDON_SOCIALS,
                        quantity: this.state.subscription.minAddOns
                    }]),
                    termShortLabel = (this.state.subscription.term === constants.SUBSCRIPTION_TERM_MONTHLY) ? 'mo' : 'yr',
                    buttonAction = (this.state.isUpgrading) ? null : this.updateSubscription;;

                headline = `Upgrade to add more socials`;
                buttonLabel = (this.state.isUpgrading) ? (<i className="fa fa-spinner fa-pulse"></i>) : 'Expand your plan';

                modalContent = (
                    <div className="current-subscription subaccount-modal">
                        <div className="add-on-block">
                            <h3>{"Boost your plan and post to more social profiles."}</h3>
                            <div className="add-on-controls clearfix">
                                <div className="add-on-buttons">
                                    <div className="add-on-button increment" data-addons="1" onClick={this.changePlan} role="button" aria-label="+1 add-on">
                                        <i className="fa fa-plus"></i>
                                    </div>
                                    <div className="current-add-on-qty">
                                        {this.state.subscription.addOns}
                                    </div>
                                    <div className="add-on-button decrement" data-addons="-1" onClick={this.changePlan} role="button" aria-label="-1 add-on">
                                        <i className="fa fa-minus"></i>
                                    </div>
                                </div>
                                <div className="add-on-display">
                                    <div className="add-on-cell">
                                        <div className="add-on-qty">
                                            + {limits.addOnOutputs}
                                        </div>
                                        <div className="add-on-label">
                                            social profiles
                                        </div>
                                    </div>
                                    <div className="add-on-cell">
                                        <div className="add-on-qty">
                                            + {limits.addOnInputs}
                                        </div>
                                        <div className="add-on-label">
                                            feeds & sites
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="add-on-totals">
                                <ul className="plan-sums">
                                    <li>
                                        <div className="line-item-flex-wrapper">
                                            <div className="line-item">
                                                {'dlvr.it ' + this.props.plans.details[this.state.subscription.level].label}
                                            </div>
                                            <div className="line-resource-count">
                                                <span className="resource-total">({currentLimits.baseOutputs} socials + {currentLimits.baseInputs} feeds)</span>
                                            </div>
                                        </div>
                                        <div className="line-total">
                                            <FormattedNumber value={this.props.user.plan.price} style="currency" currency="USD"/> / {termShortLabel}
                                        </div>
                                    </li>
                                    <li className="last-term">
                                        <div className="line-item-flex-wrapper">
                                            <div className="line-item">
                                                {this.state.add_on_social} Add-ons
                                            </div>
                                            <div className="line-resource-count">
                                                <span className="resource-total">({limits.addOnOutputs} socials + {limits.addOnInputs} feeds)</span>
                                            </div>
                                        </div>
                                        <div className="line-total">
                                            <FormattedNumber value={limits.addOnPrice} style="currency" currency="USD"/> / {termShortLabel}
                                        </div>
                                    </li>
                                    <li>
                                        <div className="line-item-flex-wrapper">
                                            <div className="line-item">
                                                Total
                                            </div>
                                            <div className="line-resource-count">
                                                <span className="resource-total">({limits.outputs} socials + {limits.inputs} feeds)</span>
                                            </div>
                                        </div>
                                        <div className="line-total">
                                            <FormattedNumber value={limits.price} style="currency" currency="USD"/> / {termShortLabel}
                                        </div>
                                    </li>
                                </ul>
                                <div className="add-on-button-wrapper">
                                    <button className="btn-flat add-on-button expand" onClick={buttonAction}>
                                        {buttonLabel}
                                    </button>
                                </div>
                                <div className="add-on-disclosures">
                                    You’ll be charged just the prorated amount this billing cycle.
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }

            content = (
                <Modal
                    close={() => {
                        this.props.closeAllModals();
                        this.props.toggleModal(false);
                    }}
                    content={modalContent}
                    headerContent={headline}
                    wrapperClass="suspended-modal opaque" />
            );
        }

        return content;
    }
}

SubaccountSubscriptionModal.displayName = "SubaccountSubscriptionModal";

const enhance = compose(
	PricingModule
);

export default enhance(SubaccountSubscriptionModal);
